var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-view"},[_c('p',[_c('span',{style:(("color: " + (_vm.symbol.color)))},[_vm._v(_vm._s(_vm.symbol.string))]),_vm._v(" "+_vm._s(_vm.card.type))])])}
var staticRenderFns = []

export { render, staticRenderFns }